import { render, staticRenderFns } from "./StreamingBox.vue?vue&type=template&id=48f5b242&scoped=true&"
import script from "./StreamingBox.vue?vue&type=script&lang=js&"
export * from "./StreamingBox.vue?vue&type=script&lang=js&"
import style0 from "./StreamingBox.vue?vue&type=style&index=0&id=48f5b242&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f5b242",
  null
  
)

export default component.exports